/**
 * [INPUT]: 依赖 ../scorer 的 RejectCode/RejectResult
 * [OUTPUT]: 对外提供 reject(code) 构造器与文案表 REJECT_COPY
 * [POS]: apps/web/pipeline 的拒绝层，集中所有拒绝码→文案映射；对齐 docs §4.2
 * [PROTOCOL]: 变更时更新此头部，然后检查 ../../CLAUDE.md
 */
import type { RejectCode, RejectResult } from '../scorer'

export const REJECT_COPY: Record<RejectCode, { message: string; hints: string[] }> = {
  NO_FACE: { message: 'No face detected', hints: ['Face the camera directly', 'Ensure good lighting and an unobstructed face'] },
  MULTI_FACE: { message: 'Please use a single-person front-facing photo', hints: ['Crop to only yourself', 'Avoid group photos'] },
  POSE_YAW: { message: 'Please face the camera directly', hints: ['Avoid turning your head left or right', 'Keep your face parallel to the camera'] },
  POSE_PITCH: { message: 'Please look straight at the camera', hints: ['Avoid tilting your head up or down', 'Keep your face level'] },
  POSE_ROLL: { message: 'Please keep your head straight', hints: ['Keep both eyes horizontally level'] },
  FACE_TOO_SMALL: { message: 'Face too small in frame', hints: ['Move closer to the camera', 'Or crop the image tighter'] },
  BLUR: { message: 'Photo is blurry — please retake', hints: ['Ensure sharp focus', 'Hold the camera steady'] },
  LIGHTING: { message: 'Poor lighting — please retake', hints: ['Avoid harsh shadows or overexposure', 'Use even, diffuse lighting'] },
  OCCLUSION: { message: 'Please remove obstructions', hints: ['Take off masks and sunglasses', 'Show your full face clearly'] },
  INVALID_FILE: { message: 'Unable to read image', hints: ['Only JPG, PNG, or WebP supported', 'File size must be ≤ 10MB'] },
}

export function reject(code: RejectCode): RejectResult {
  const copy = REJECT_COPY[code]
  return { ok: false, code, message: copy.message, hints: copy.hints }
}